<template>
  <div class="animated fadeIn">
    <div class="row">
      <h3>Relatórios</h3>
    </div><!--/.row-->
  </div>
</template>

<script>
export default {
  name: 'reports'
}
</script>



// WEBPACK FOOTER //
// src/views/private/reports/reports.vue